// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"17b9a347","260":"882e7e7a","365":"284cbc8b","379":"5190a4e4","391":"6a520643","401":"b03a408f","705":"e04e121e","787":"6a28f8c3","848":"9cf844dd","873":"d8703933"}[chunkId] + ".chunk.js";
};